import { FlightState } from "../views/FlightDetailsView/models/FlightModels.js";
import { compareIgnoreCase } from "@ane/core/lib/utils/CommonStringUtils";
import ___default from "lodash";
import EnvironmentService from "@ane/core/lib/services/EnvironmentService";
import { getTenantFromManagementGroup } from "@ane/exp-data/lib/utils/ManagementGroup";
import "./flight.constants.js";
import { BING_SETFLIGHT_LINK } from "@ane/exp-data/lib/routes/FlightRoute.utils";
const isFlightManagementDisabled = () => {
  return EnvironmentService.isUnifiedView || !EnvironmentService.isUnifiedView && EnvironmentService.disableFlightManagementInCT();
};
const parseFlightOverviewDto = (flightOverview) => {
  if (!flightOverview) {
    return null;
  }
  return {
    currentFlightInfo: parseFlightCurrentInfoDto(flightOverview.CurrentFlightInfo),
    isStandardControl: flightOverview.IsStandardControl || false,
    expiryTimeUtc: flightOverview.ExpiryTimeUtc || null,
    plans: flightOverview.Plans || [],
    livesiteLink: getLivesiteLink(flightOverview.CurrentFlightInfo.FlightName, flightOverview.CurrentFlightInfo.ManagementGroup)
  };
};
const getLivesiteLink = (flightId, managementGroup) => {
  return compareIgnoreCase(getTenantFromManagementGroup(managementGroup), "bing") ? `${BING_SETFLIGHT_LINK}${flightId}` : null;
};
const parseFlightCurrentInfoDto = (currentDetails) => {
  var _a, _b;
  return {
    flightName: currentDetails.FlightName,
    description: currentDetails.Description,
    owners: currentDetails.Owners || [],
    isolationGroups: currentDetails.IsolationGroups || [],
    numberline: currentDetails.NumberLine || null,
    flightGroup: (_a = currentDetails.FlightGroup) != null ? _a : null,
    resaltSeed: (_b = currentDetails.ResaltSeed) != null ? _b : null,
    rotationState: parseFlightState(currentDetails.RotationState),
    workspaceId: EnvironmentService.getWorkspaceIdOrDefault(currentDetails.WorkspaceId),
    tenant: currentDetails.Tenant,
    managementGroup: currentDetails.ManagementGroup,
    workingCompositions: currentDetails.WorkingCompositions || [],
    isFeatureComposed: currentDetails.IsFeatureComposed || false
  };
};
const parseFlightState = (state) => {
  if (compareIgnoreCase(state, "running")) {
    return FlightState.Running;
  } else if (compareIgnoreCase(state, "Stopped")) {
    return FlightState.Stopped;
  }
  return FlightState.NotSet;
};
const createExpIdScorecardMapping = (expIds, scorecardIds) => {
  const result = {};
  ___default.forEach(scorecardIds, (data, index) => {
    result[expIds[index]] = data;
  });
  return result;
};
const convertFormValuesToFlightConfiguration = (formValues, props) => {
  return {
    Name: formValues.name,
    Description: formValues.description,
    Owners: formValues.owners,
    WorkspaceId: props.workspaceId,
    ManagementGroup: formValues.managementGroup,
    IsolationGroups: formValues.isolationGroups
  };
};
export {
  convertFormValuesToFlightConfiguration,
  createExpIdScorecardMapping,
  getLivesiteLink,
  isFlightManagementDisabled,
  parseFlightCurrentInfoDto,
  parseFlightOverviewDto,
  parseFlightState
};
//# sourceMappingURL=FlightUtils.js.map
